import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import EMDBcart from  '../../utils/emdb.cart.js'

//CSS
import styles from './VTCart.module.less';

function Product({product, t, i18n, handleDeleteProduct}) {
  const laguagenames={"es":t('español'),"en":t('ingles'),"fr":t('frances'),"it":t('italiano'),"de":t('aleman'),"ru":t('ruso')};
  const dias = Array.from({ length: 30 }, (_, index) => index + 1);
  const listOptions= dias.map((dia)=>{return <option key={dia} value={dia}>{dia}</option>})
  let totaltamount=0.0;

  console.log(product.language);

  const listContents = Object.keys(product.contents).map(idcontent => {
    const amount = product.contents[idcontent].price * product.contents[idcontent].numberItems - product.contents[idcontent].discount;
    totaltamount += amount;

    return (
      <div className={styles.itemPax} key={product.contents[idcontent].id} data-id={product.contents[idcontent].id} data-supplement={product.contents[idcontent].supplement} >
        <div className={styles.name}> {product.contents[idcontent].description[i18n.language] ? product.contents[idcontent].description[i18n.language]:product.contents[idcontent].description['es']} ({product.contents[idcontent].price.toFixed(2)} &euro;) </div>
        <div className={styles.select}>
          <select className={styles.selectnumpax} defaultValue={product.contents[idcontent].numberItems}>
            {listOptions}
          </select>
        </div>
      </div>
    );
  });

  const photourl="https://storage.viajesteide.es/images/excursions/" + product.excursion_id + "_webthumb.jpg";

  return (
    <div className={styles.cartItem} key={product.id} data-id={product.id} data-date={product.date}>
      <div className={styles.photo}><img src={photourl} /></div>
      <div className={styles.info}>
        <div className={styles.title}>{product.name[i18n.language] ? product.name[i18n.language]:product.name['es']}</div>
        <div className={styles.date}><b>{t('fecha')}: </b>{product.date}</div>
        <div className={styles.language}><b>{t('idioma')}: </b>{laguagenames[product.language]}</div>
        <div className={styles.content}>
          {listContents}
        </div>
      </div>
      <div className={styles.actions}>
        <div className={styles.totalprice}>{t('price')} <b>{totaltamount.toFixed(2)} &euro;</b></div>
        <div className={styles.delete} onClick={()=>handleDeleteProduct(product.id)}>
          <div className={styles.deleteicon}></div>
          <div className={styles.text}>{t('delete')}</div>
        </div>
      </div>
    </div>
  );
}

function VTCart({config}) {
  const [cart, setCart] = useState(new EMDBcart('vtformcart'));
  const {t, i18n} = useTranslation(["vtcart"]);
  const language = (config.hasOwnProperty('locale')) ? config.locale : 'es';
  const productsCart=cart.getCartProducts();
  const numProductsCart=cart.getNumProducts();
  let listProducts;

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);

  useEffect(() => {
    //Comprobamos evento Storage para saber si se actualizo el carro
    const handleStorage = () => {
      //Actualizamos el objeto con el carro
      setCart(new EMDBcart('vtformcart'));
    }
    document.addEventListener('storage', handleStorage)
    return () => document.removeEventListener('storage', handleStorage)
  }, [])

  if (numProductsCart >0 ){
    listProducts = Object.keys(productsCart).map(idproduct =>{
      return <Product key={productsCart[idproduct].id} product={productsCart[idproduct]} t={t} i18n={i18n} handleDeleteProduct={(idproduct)=>cart.deleteProduct(idproduct)} />;
    });
  }else{
    listProducts =
      <div className={styles.cartEmpty}>
        {t('El carro de la compra esta vacio')}
      </div>
  }

  return (
    <div className={styles.cart}>
      <div className={styles.header}>
        <h3>{t('Resumen de compra')}</h3>
      </div>

      <div className={styles.cartItems}>
        {listProducts}
      </div>
    </div>
  );
}

export default VTCart;